var React = require('react');

function Networking (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"id":"Artboard1","x":"0","y":"0","width":"80","height":"68","style":{"fill":"none"},"key":0}),React.createElement("g",{"key":1},[React.createElement("rect",{"x":"30","y":"54","width":"20","height":"14","key":0}),React.createElement("rect",{"x":"30","y":"0","width":"20","height":"14","key":1}),React.createElement("rect",{"x":"0","y":"54","width":"20","height":"14","key":2}),React.createElement("rect",{"x":"60","y":"54","width":"20","height":"14","key":3}),React.createElement("path",{"d":"M42,32l0,-14l-4,0l0,14l-30,0l0,18l4,0l0,-14l26,0l0,14l4,0l0,-14l26,0l0,14l4,0l0,-18l-30,0Z","style":{"fillRule":"nonzero"},"key":4})])]);
}

Networking.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 80 68","version":"1.1","xmlSpace":"preserve","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"1.41421"}};

module.exports = Networking;

Networking.default = Networking;



// WEBPACK FOOTER //
// ./static/assets/networking5.svg